module.exports = __webpack_public_path__ + "img/BusinessCardAD (1).c4178df3.png";